// AbortControllers stored outside Vuex state (not reactive-proxy-safe)
const controllers = new Map()

export const state = () => ({
  queue: []
})

export const getters = {
  queue: x => x.queue,
  activeCount: x => x.queue.filter(i => i.status === 'uploading').length,
  hasItems: x => x.queue.length > 0
}

export const mutations = {
  ADD_ITEM(state, item) {
    state.queue.push(item)
  },
  UPDATE_ITEM(state, { id, progress, status }) {
    const item = state.queue.find(i => i.id === id)
    if (item) {
      if (progress !== undefined) item.progress = progress
      if (status !== undefined) item.status = status
    }
  },
  REMOVE_ITEM(state, id) {
    const idx = state.queue.findIndex(i => i.id === id)
    if (idx !== -1) state.queue.splice(idx, 1)
    controllers.delete(id)
  },
  CLEAR_QUEUE(state) {
    state.queue.forEach(i => controllers.delete(i.id))
    state.queue = []
  }
}

export const actions = {
  addItem({ commit, dispatch }, file) {
    const id = Date.now() + Math.random()
    const controller = new AbortController()
    controllers.set(id, controller)

    let previewUrl = null
    if (file.type.startsWith('image/')) {
      previewUrl = URL.createObjectURL(file)
    }

    const item = { id, name: file.name, size: file.size, progress: 0, status: 'uploading', mimeType: file.type, previewUrl, fileBlob: file }
    commit('ADD_ITEM', item)

    // Switch sidepanel to Notification tab to show uploads
    dispatch('sidepanel/setActiveTab', 'default', { root: true })

    return { ...item, controller }
  },
  updateItem({ commit }, payload) {
    commit('UPDATE_ITEM', payload)
  },
  removeItem({ commit }, id) {
    const controller = controllers.get(id)
    if (controller) controller.abort()
    commit('REMOVE_ITEM', id)
  },
  dismissAll({ commit }) {
    commit('CLEAR_QUEUE')
  },
  getController(_, id) {
    return controllers.get(id)
  }
}
